module.exports = __webpack_public_path__ + "img/loading.0e740953.png";